// import TestCalendarTesting from './TestCalendarTesting';
// import Login from '../../../../modules/Login/LoginEvent'; // adjust path as needed
// import Teams from '../../../Tab';
// import Web from '../../../Tab1';

// const msHomeAccountId = sessionStorage.getItem('msHomeAccountId');

// export default function CalendarEntryPoint(props) {
//   console.log("msHomeAccountId in CalendarEntryPoint:", msHomeAccountId);
//   if (msHomeAccountId) {
//     return <Teams {...props} />;
//   } else {
//     return <Web />;
//   }
// }

import * as microsoftTeams from "@microsoft/teams-js";
import { useEffect, useState } from "react";

import Teams from "./TeamsTab";
import Web from "./WebTab";
import { Toaster } from 'react-hot-toast';
import Responsive from "../modules/Responsive/Responsive";
import { initFormSuccessHandler } from "../assets/demo/js/custom-script";

export default function CalendarEntryPoint(props) {
  const [msHomeAccountId, setMsHomeAccountId] = useState(null);
  const [isTeams, setIsTeams] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const cleanup = initFormSuccessHandler();

    return () => cleanup && cleanup();
  }, []);

  useEffect(() => {
    const init = async () => {
      try {
        const runningInIframe = window.self !== window.top;

        if (!runningInIframe) {
          setIsTeams(false);
          setIsLoading(false);
          return;
        }

        setIsTeams(true);
        await microsoftTeams.app.initialize();
        const context = await microsoftTeams.app.getContext();

        const accountId =
          context?.user?.id || context?.userObjectId;

        if (!accountId) {
          throw new Error("Microsoft Teams account ID not found");
        }

        sessionStorage.setItem("msHomeAccountId", accountId);

        console.log("Account ID in CalendarEntryPoint:", accountId);
        setMsHomeAccountId(accountId);
      } catch (err) {
        console.error("Teams init failed:", err);
        setError("Unable to initialize Microsoft Teams");
      } finally {
        setIsLoading(false);
      }
    };

    init();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!isTeams) {
    return <div>
      <Toaster position="top-right" reverseOrder={false} />
      {/* <MyMapComponent /> */}
      <Web />
      <Responsive />
    </div>
    // <Router>
    //  <ProtectedRoute>
    //  <Web />;
    // </ProtectedRoute>
    // </Router>
  }

  if (msHomeAccountId) {
    return <Teams {...props} />;
  }
}
